class ProductNavigationLinks extends HTMLElement {
  constructor() {
    super();
  }

  selectors = {
    list: "[data-navigation-list]",
    item: "[data-navigation-item]",
    link: "[data-navigation-link]"
  };

  modifiers = {
    hidden: "hidden"
  };

  get linkElements() {
    return this.querySelectorAll(this.selectors.link);
  }

  connectedCallback() {
    this.pruneNonexistentLinks();
  }

  pruneNonexistentLinks() {
    this.linkElements.forEach(link => {
      const targetSelector = link.getAttribute("href");
      const targetElement = document.querySelector(targetSelector);

      if (!targetElement) {
        link.closest(this.selectors.item)?.remove();
      }
    });

    const listElement = this.querySelector(this.selectors.list);
    if (listElement && listElement.children.length === 0) {
      this.parentElement.classList.add("hidden");
    }
  }
}

customElements.define("product-navigation-links", ProductNavigationLinks);
